export default __webpack_public_path__ + "static/media/jardinsPrivesTwitter-600x314.64db4699.jpg";